/**
 * Utilitário para conversão entre minutos e formato HH:mm
 */

/**
 * Converte minutos em formato "HH:mm"
 * @param minutos - Total de minutos
 * @returns String no formato "HH:mm" (ex: "02:30")
 */
export function minutosParaHorasMinutos(minutos: number | null | undefined): string {
  if (minutos === null || minutos === undefined || minutos < 0) {
    return '00:00';
  }

  const horas = Math.floor(minutos / 60);
  const mins = minutos % 60;

  return `${String(horas).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
}

/**
 * Converte formato "HH:mm" em minutos
 * @param horasMinutos - String no formato "HH:mm" (ex: "02:30")
 * @returns Total de minutos
 */
export function horasMinutosParaMinutos(horasMinutos: string | null | undefined): number {
  if (!horasMinutos || typeof horasMinutos !== 'string') {
    return 0;
  }

  // Remove espaços e valida formato básico
  const limpo = horasMinutos.trim();
  const regex = /^(\d{1,3}):(\d{2})$/;
  const match = limpo.match(regex);

  if (!match) {
    // Tenta aceitar apenas números (assume que são minutos)
    const apenasNumeros = parseInt(limpo, 10);
    if (!isNaN(apenasNumeros)) {
      return apenasNumeros;
    }
    return 0;
  }

  const horas = parseInt(match[1], 10);
  const minutos = parseInt(match[2], 10);

  // Validação adicional
  if (minutos >= 60) {
    return 0;
  }

  return (horas * 60) + minutos;
}

/**
 * Valida formato "HH:mm"
 * @param horasMinutos - String para validar
 * @returns true se válido
 */
export function validarFormatoHorasMinutos(horasMinutos: string): boolean {
  if (!horasMinutos || typeof horasMinutos !== 'string') {
    return false;
  }

  const regex = /^(\d{1,3}):(\d{2})$/;
  const match = horasMinutos.trim().match(regex);

  if (!match) {
    return false;
  }

  const minutos = parseInt(match[2], 10);
  return minutos < 60;
}

/**
 * Formata um input para aceitar apenas HH:mm
 * @param valor - Valor digitado
 * @returns Valor formatado
 */
export function formatarInputHorasMinutos(valor: string): string {
  // Remove tudo que não é número ou ':'
  let limpo = valor.replace(/[^\d:]/g, '');
  
  // Divide em partes
  const partes = limpo.split(':');
  
  if (partes.length === 1) {
    // Se tem só números, adiciona ':' após 2 dígitos
    if (limpo.length > 2) {
      return limpo.slice(0, 2) + ':' + limpo.slice(2, 4);
    }
    return limpo;
  }
  
  if (partes.length >= 2) {
    // Limita horas a 3 dígitos e minutos a 2
    const horas = partes[0].slice(0, 3);
    const minutos = partes[1].slice(0, 2);
    return `${horas}:${minutos}`;
  }
  
  return limpo;
}

